import { render, staticRenderFns } from "./veSbzcZcRetireShow.vue?vue&type=template&id=10038582&scoped=true"
import script from "./veSbzcZcRetireShow.vue?vue&type=script&lang=js"
export * from "./veSbzcZcRetireShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10038582",
  null
  
)

export default component.exports